import React from 'react'
import { TabPane } from 'reactstrap'
import { AdvancedFiltersScope } from './filterUrl'

// A reactstrap TabPane for detail pages that keep visited tabs mounted but
// hidden (Cars/CarDetailNew/CarDetailContainer.js,
// Drivers/Driver/Detail/DetailsNew/DriverDetailContainerNew.js). Every tab on
// such a page shares the one `?filter=` param, so each pane is wrapped in an
// AdvancedFiltersScope that is active only while the pane is showing -- a
// hidden pane then keeps its own filters instead of re-running its query with
// another tab's. Use it for every pane, so a list that gains Advanced Filters
// later is covered without anyone having to remember this.
export default function ScopedTabPane({ activeTab, tabId, children, ...rest }) {
    return (
        <TabPane tabId={tabId} {...rest}>
            <AdvancedFiltersScope active={activeTab === tabId}>{children}</AdvancedFiltersScope>
        </TabPane>
    )
}
